"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateRecruitmentRequestSchema = exports.CreateRecruitmentRequestSchema = exports.RecruitmentSearchQuerySchema = exports.RecruitmentIdPathParamsSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
exports.RecruitmentIdPathParamsSchema = zod_1.z.object({ recruitmentId: schemas_1.UUIDSchema });
exports.RecruitmentSearchQuerySchema = schemas_1.PaginationQuerySchema.extend({
    search: zod_1.z.string().optional(),
    status: zod_1.z.enum(['DRAFT', 'ACTIVE', 'PAUSED', 'CLOSED']).optional(),
});
exports.CreateRecruitmentRequestSchema = zod_1.z.object({
    description: zod_1.z.string().min(1),
    applicationMethod: zod_1.z.string().optional(),
    benefits: zod_1.z.string().optional(),
    coverImage: zod_1.z.string().optional(),
    eligibility: zod_1.z.string().optional(),
    employmentStatus: zod_1.z.string(),
    estimatedSalaryMax: zod_1.z.number().optional(),
    estimatedSalaryMin: zod_1.z.number().optional(),
    highlights: zod_1.z.array(zod_1.z.string()).optional(),
    holidayInfo: zod_1.z.string().optional(),
    images: zod_1.z.array(zod_1.z.string()).optional(),
    industryId: schemas_1.UUIDSchema,
    locationDetail: zod_1.z.string().optional(),
    locationDistrictId: schemas_1.UUIDSchema.optional(),
    memo: zod_1.z.string().optional(),
    occupationId: schemas_1.UUIDSchema,
    searchKeywords: zod_1.z.array(zod_1.z.string()).optional(),
    testimonial: zod_1.z.string().optional(),
    title: zod_1.z.string().min(1).max(200),
    workHours: zod_1.z.string().optional(),
});
exports.UpdateRecruitmentRequestSchema = exports.CreateRecruitmentRequestSchema.partial().extend({
    status: zod_1.z.enum(['DRAFT', 'ACTIVE', 'PAUSED', 'CLOSED']).optional(),
});
